<div class="leads-container">
  <!-- Header: Title + Toggle -->
  <div class="leads-header">
    <h1 class="page-title hide-mobile">Leads (Clientes potenciales)</h1>
    <div class="switch-status">
      <span>{{
        leadsEnabled ? 'Desactivar obtención de Leads' : 'Activar obtención de Leads'
      }}</span>
      <p-inputSwitch [(ngModel)]="leadsEnabled" (onChange)="onLeadsToggle($event)"></p-inputSwitch>
    </div>
  </div>

  <!-- Filter Bar -->
  <div class="filter-bar" *ngIf="leadsEnabled">
    <div class="filter-row">
      <!-- Search -->
      <span class="p-input-icon-left filter-search">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          [(ngModel)]="searchTerm"
          (input)="onSearchInput()"
          placeholder="Buscar por nombre, email o teléfono..."
          class="w-full"
        />
      </span>

      <!-- Status Filter -->
      <p-dropdown
        [options]="statusOptions"
        [(ngModel)]="selectedStatus"
        (onChange)="onFilterChange()"
        placeholder="Estado"
        [style]="{ minWidth: '150px' }"
      ></p-dropdown>

      <!-- Channel Filter -->
      <p-dropdown
        [options]="channelOptions"
        [(ngModel)]="selectedChannel"
        (onChange)="onFilterChange()"
        placeholder="Canal"
        [style]="{ minWidth: '150px' }"
      ></p-dropdown>

      <!-- Date Range -->
      <p-calendar
        [(ngModel)]="rangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        [showIcon]="true"
        placeholder="Rango de fechas"
        dateFormat="dd/mm/yy"
        (onSelect)="onDateSelect()"
        [style]="{ minWidth: '220px' }"
      ></p-calendar>

      <!-- Export Button -->
      <button
        *ngIf="canExport"
        pButton
        icon="pi pi-download"
        label="Exportar"
        (click)="exportToExcel()"
        [loading]="isLoading"
      ></button>
    </div>
  </div>

  <!-- Table -->
  <div class="content-card" *ngIf="leadsEnabled">
    <p-table
      [value]="leads"
      [lazy]="true"
      (onLazyLoad)="loadLeads($event)"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [first]="first"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} leads"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" style="width: 10rem">Estado</th>
          <th scope="col">Canal</th>
          <th scope="col">Nombre</th>
          <th scope="col">Email</th>
          <th scope="col">Teléfono</th>
          <th scope="col">Motivo de contacto</th>
          <th scope="col">Fecha</th>
          <th scope="col" style="width: 5rem"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-lead>
        <tr>
          <!-- Status with inline change -->
          <td>
            <ng-container
              *ngIf="
                canEdit && getAvailableTransitions(lead.status).length > 0;
                else readOnlyStatus
              "
            >
              <p-dropdown
                [options]="getAvailableTransitions(lead.status)"
                [ngModel]="lead.status"
                (onChange)="onStatusChange(lead, $event.value)"
                placeholder="{{ getStatusLabel(lead.status) }}"
                appendTo="body"
              >
                <ng-template pTemplate="selectedItem">
                  <p-tag
                    [value]="getStatusLabel(lead.status)"
                    [severity]="getStatusSeverity(lead.status)"
                  ></p-tag>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  {{ option.label }}
                </ng-template>
              </p-dropdown>
            </ng-container>
            <ng-template #readOnlyStatus>
              <p-tag
                [value]="getStatusLabel(lead.status)"
                [severity]="getStatusSeverity(lead.status)"
              ></p-tag>
            </ng-template>
          </td>
          <td>{{ lead.origin || '--' }}</td>
          <td>
            {{ lead.client?.name || '--' }}
            <p-badge
              *ngIf="lead.recurring_info?.is_recurring"
              value="R"
              severity="warning"
              [pTooltip]="
                'Contacto recurrente (' +
                lead.recurring_info.previous_leads_count +
                ' leads previos)'
              "
              tooltipPosition="top"
            ></p-badge>
          </td>
          <td>{{ lead.client?.email || '--' }}</td>
          <td>{{ lead.client?.phone || '--' }}</td>
          <td>{{ lead.requirement || '--' }}</td>
          <td>{{ lead.created_at | customDate }}</td>
          <td>
            <p-button
              (onClick)="showDialog(lead.correlation_id)"
              icon="pi pi-search"
              styleClass="p-button-rounded p-button-text p-button-info"
              ariaLabel="Ver conversación del lead"
            ></p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="text-center p-4">
            <i class="pi pi-table" style="font-size: 2rem; color: var(--text-color-secondary)"></i>
            <p class="mt-2">No se encontraron leads</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Leads disabled state -->
  <div class="no-data content-card" *ngIf="!leadsEnabled">
    <i class="pi pi-table"></i>
    <p style="max-width: 530px; text-align: center; line-height: 20px">
      Activa la obtención de leads para que tu asistente detecte interés y recoja datos como email y
      teléfono de tus clientes.
    </p>
  </div>

  <!-- Conversation Dialog -->
  <p-dialog
    header="Conversación detallada"
    [modal]="true"
    [(visible)]="visible"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }"
    [draggable]="false"
    [resizable]="false"
  >
    <div class="message">
      <globot-chat-messages-list
        *ngIf="selectedChatHistory.length > 0"
        [chatGroups]="selectedChatHistory"
      ></globot-chat-messages-list>
      <!-- GLOB-1888: el detalle puede no existir (conversación sin mensajes) -->
      <p *ngIf="selectedChatHistory.length === 0" class="conversation-empty">
        Esta conversación no tiene mensajes disponibles
      </p>
    </div>
  </p-dialog>
</div>
